import React, { useState, useEffect } from "react";
import { Spinner } from "../../StyledComponent";
import { getComoOndeFinanciar } from "../../../services/meAjuda";
import ImagemVideo from "../../../assets/novosicones/MeAjuda/imagemComoOndeFinanciar.png";
import "./styles.scss";
const FinanciamentoComponent = ({ tema }) => {
  const [loading, setLoading] = useState(false);
  const [comoOndeFinanciar, setComoOndeFinanciar] = useState([]);
  const [texto2, setTexto2] = useState([]);
  useEffect(() => {
    get();
  }, []);

  async function get() {
    setLoading(true);

    let resultGetComoOndeFinanciar = await getComoOndeFinanciar();
    if (resultGetComoOndeFinanciar.length > 0) {
      setComoOndeFinanciar(resultGetComoOndeFinanciar);
      trataTextoDois(resultGetComoOndeFinanciar[0].TextoDois);
    } else {
      setComoOndeFinanciar([]);
    }
    setLoading(false);
  }

  function trataTextoDois(textoDois) {
    {
      setTexto2(textoDois.split(";"));
    }
  }

  if (loading) return <Spinner />;

  if (comoOndeFinanciar.length == 0) return <p>Indisponível no momento.</p>;

  return (
    <div className="meAjudaComoOndeFinanciar">
      <div
        className="centralized meAjudaComoOndeFinanciar__titulo"
        style={{ backgroundColor: tema }}
      >
        <p>Como dar entrada no financiamento do seu imóvel</p>
      </div>
      <p>{comoOndeFinanciar[0].Texto}</p>
      <a target="_blank" rel="noreferrer" href={comoOndeFinanciar[0].Link}>
        <img src={ImagemVideo} alt="" />
      </a>
      {texto2.map((item, index) => {
        return (
          <>
            {index < texto2.length - 1 ? (
              <p key={index}>{item + ";"}</p>
            ) : (
              <p key={index}>{item}</p>
            )}
          </>
        );
      })}
    </div>
  );
};

export default FinanciamentoComponent;
